import { createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { getUsageEstimate } from '../services/UsageEstimatePublicService';

export const useUsageEstimatePublicGetUsageEstimate = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(getUsageEstimate, 'requestBody', 'data'),
      'data',
      'residents',
      'buildingType',
      'buildingAge',
      'energyType',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['residents', 'buildingType', 'buildingAge', 'energyType'] },
    ],
  },
);
